import { FC, useId } from 'react';

import { ControlsContainer } from '@eneco/custom-components/Graph';
import { InputSelect, Stack, ToggleSwitch, Text, Stretch } from '@eneco/sparky';
import { useContent } from '@sitecore/common';
import { DynamicPricingTariffsRendering } from '@sitecore/types/DynamicPricingTariffs';

import { useDynamicPricingTariffsOptional } from '../../../hooks/useDynamicPricingTariffs';
import { graphViewOptions } from '../../../utils/constants';
import { GraphProductOption, GraphViewOption } from '../../../utils/types';

export const GraphControls: FC = () => {
  const { fields } = useContent<DynamicPricingTariffsRendering>();

  const showTotalLabelId = useId();

  const context = useDynamicPricingTariffsOptional();

  if (!context) return null;
  const { productTypes, selectedView, setSelectedView, selectedProduct, setSelectedProduct, showTotal, setShowTotal } =
    context;

  const productOptions = productTypes?.map(product => ({
    value: product,
    label: fields?.[`${product}ProductLabel`]?.value,
  }));

  const viewOptions = graphViewOptions.map(option => ({
    value: option,
    label: fields?.[`${option}ViewLabel`]?.value,
  }));

  return (
    <ControlsContainer>
      <Stack.Item>
        <Stack direction="row" gap="6">
          {productOptions?.length ? (
            <InputSelect
              options={productOptions}
              label={fields?.selectedProductLabel?.value}
              name="products"
              placeholder={fields?.selectedProductLabel?.value}
              value={selectedProduct}
              onChange={e => setSelectedProduct(e.target.value as GraphProductOption)}
            />
          ) : null}
          <InputSelect
            name="intervals"
            options={viewOptions}
            label={fields?.selectedViewLabel?.value}
            placeholder={fields?.selectedViewLabel?.value}
            value={selectedView}
            onChange={e => setSelectedView(e.target.value as GraphViewOption)}
          />
        </Stack>
      </Stack.Item>
      <Stretch width={{ initial: true, md: false }}>
        <Stack gap="4">
          <Stack direction="row" gap="6" alignX="justify">
            <Stack direction="column" gap="1">
              <Text weight="bold" size="BodyS" id={showTotalLabelId}>
                {fields?.showTotalLabel?.value}
              </Text>
              <Text size="BodyXS">{fields?.showTotalText?.value}</Text>
            </Stack>
            <ToggleSwitch
              name="showTotal"
              aria-labelledby={showTotalLabelId}
              isChecked={showTotal}
              onCheckedChange={e => setShowTotal(e)}
            />
          </Stack>
        </Stack>
      </Stretch>
    </ControlsContainer>
  );
};
